import { makeStyles, Theme } from '@material-ui/core/styles';
import { convertPxToRem } from '../common/utils/helpers/GenericHelpers';

export const baseStyles = makeStyles((theme: Theme) => ({
    html: {
        scrollBehavior: 'smooth',
    },
    main: {
        margin: '0 auto',
        padding: convertPxToRem(10),
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    },
    hr: {
        width: '100%',
        display: 'block',
        backgroundColor: `${theme.palette.primary.light}`,
        border: 'none',
        marginTop: 0,
        height: '2px',
        marginBottom: convertPxToRem(20),
    },
    h1: {
        fontSize: convertPxToRem(38),
        marginBottom: convertPxToRem(20),
        //marginTop: 50,
        fontWeight: 300,
        color: theme.palette.primary.light,
        lineHeight: convertPxToRem(40),
    },
    white: {
        backgroundColor: `${theme.palette.common.white}`,
        fontWeight: 300,
        marginTop: convertPxToRem(20),
        marginBottom: convertPxToRem(20),
        paddingBottom: convertPxToRem(30),
        paddingLeft: convertPxToRem(15),
        paddingTop: convertPxToRem(30),
    },
    chatIcon: {
        padding: '0 8px',
    },
    spacingNone: {
        marginBottom: 0,
    },
    spacingNormal: {
        marginBottom: convertPxToRem(20),
    },
    spacingMedium: {
        marginBottom: convertPxToRem(25),
    },
    spacingLarge: {
        marginBottom: convertPxToRem(30),
    },
    spacingExtraLarge: {
        marginBottom: convertPxToRem(50),
    },
    spacingBottom45: {
        marginBottom: convertPxToRem(45),
    },
    htmlWrapper: {
        '& a': {
            textDecoration: 'underline',
            color: '#53759b',
            '&:hover': {
                color: '#131947',
            },
        },
        '& p': {
            fontSize: convertPxToRem(20),
            fontWeight: 300,
            lineHeight: '1.5rem',
        },
        '& h4:last-child': {
            marginBottom: convertPxToRem(12),
        },
    },
    hidden: {
        display: 'none',
    },
    buttonProgress: {
        color: theme.palette.common.white,
    },
    cvrModal: {
        margin: '1.5rem 2rem 3rem',
    },
}));
